(function () {
  var pageViewSent = false;

  function sendPageViewOnce() {
    if (pageViewSent || window.__openAIConsentGranted !== true || typeof window.oaiq !== 'function') return;
    pageViewSent = true;
    try {
      var key = 'flexlearn_openai_page_viewed:' + window.location.pathname + window.location.search;
      if (sessionStorage.getItem(key) === '1') return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}

    window.oaiq('measure', 'page_viewed', {
      type: 'contents',
      contents: [{
        id: window.location.pathname,
        name: document.title || window.location.pathname,
        content_type: 'page'
      }]
    });
    window.__openAIPageViewedQueued = true;
  }

  function setOpenAIConsent(value) {
    var granted = Boolean(value);
    window.__openAIConsentGranted = granted;
    if (typeof window.oaiq === 'function') {
      window.oaiq('consent', granted);
    }
    if (granted) sendPageViewOnce();
    try {
      window.dispatchEvent(new CustomEvent('flexlearn:openai-consent', { detail: { granted: granted } }));
    } catch (e) {}
  }

  function syncFromShopify() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    try {
      setOpenAIConsent(window.Shopify.customerPrivacy.userCanBeTracked());
    } catch (e) {}
  }

  function boot() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      window.setTimeout(boot, 150);
      return;
    }

    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function (error) {
      if (error) {
        window.__openAIConsentError = String(error);
        return;
      }
      syncFromShopify();

      document.addEventListener('trackingConsentAccepted', function () {
        setOpenAIConsent(true);
      });

      document.addEventListener('visitorConsentCollected', syncFromShopify);
    });
  }

  window.flexlearnOpenAIStatus = function () {
    return {
      pixel_expected: window.__openAIPixelExpected === true,
      queue_present: typeof window.oaiq === 'function',
      consent_granted: window.__openAIConsentGranted === true,
      page_view_queued: window.__openAIPageViewedQueued === true,
      lead_pending: window.__openAILeadPending === true,
      lead_queued: window.__openAILeadTracked === true,
      lead_event_id: window.__openAILeadEventId || null,
      consent_error: window.__openAIConsentError || null,
      scope: window.__openAIPixelScope || 'unknown',
      path: window.location.pathname,
      search: window.location.search
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
